import { useApi } from "@appretio/api";
import { useQuery } from "@tanstack/react-query";
import { forecastAggLevelStatusQueryKeys } from "./queryKeys";

/**
 * Fetches aggregation level status for a given cube.
 */
export function useFetchAggLevelStatus(
  cubeId: string,
  enabled: boolean = true
) {
  const apiClient = useApi();

  return useQuery({
    queryKey: forecastAggLevelStatusQueryKeys.data(cubeId),
    meta: {
      errorMessage: "Failed to fetch aggregation level status"
    },
    queryFn: async () => {
      const response = await apiClient.POST(
        "/v2/forecast/cubes/agg-level-status",
        {
          body: { cube_id: cubeId }
        }
      );

      return response.data?.result ?? [];
    },
    enabled: enabled && cubeId.length > 0
  });
}
